import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import ButtonWithLoader from '../../../../common/components/ui/loading/ButtonLoading';
import InputFormik from '../../../../common/components/form/InputFormik';
import { isLicensePlate } from '../../../../common/helpers/is-license-plate';
import { maskCNPJ, maskLicensePlate } from '../../../../common/helpers/mask.helpers';
import { IVehicle } from '../../../../types/vehicle.type';

const validationSchema = Yup.object().shape({
  licensePlate: Yup.string()
    .required('Placa é obrigatório')
    .test(
      'invalid-plate',
      'Placa inválida',
      isLicensePlate
    ),
  cnpj: Yup.string()
});

type FormPropsCreateRenter = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: (values: { licensePlate: string, partnerInfo: null }) => Promise<IVehicle | { ok: boolean; data: any; errors: { message: any; path: never[]; }[]; }>;
};

function FormCreateVehicle(props: FormPropsCreateRenter) {
  const initialValues = { licensePlate: '', cnpj: '' };

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    await props.onSubmit(values);
    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, handleSubmit }) => {
        return (
          <Form>
            <InputFormik
              label='CNPJ'
              name='cnpj'
              className='w-full mb-2'
              required={true}
              mask={maskCNPJ}
            />
            <InputFormik
              label='Placa'
              name='licensePlate'
              className='w-full mb-2'
              required={true}
              mask={maskLicensePlate}
            />
            <div className="flex justify-end mt-8">
              <ButtonWithLoader isLoading={isSubmitting} onClick={handleSubmit}> Enviar </ButtonWithLoader>
            </div>
          </Form>
        )
      }}
    </Formik>
  );
}

export default FormCreateVehicle;
